// extracted by mini-css-extract-plugin
export default {"Story":"Story_Story__jgDT6"};